import { createSlice, PayloadAction } from '@reduxjs/toolkit'; 

// ---------------
 
interface PatientState {
  section: string, 
  infoSection: string, 
  patient: any,
  patientsList: any[], 
  emergencyContacts: any, 
  patientIdFromFileExplorer: string, 
  refreshPatientsList: boolean, 
  initialRendering: boolean, 
};

// ---------------

const initialState: PatientState = {
  section: 'patient', 
  infoSection: 'overview', 
  patient: null,
  patientsList: [], 
  emergencyContacts: null,
  patientIdFromFileExplorer: '',
  refreshPatientsList: false, 
  initialRendering: true, 
};

// ---------------

export const patientSlice = createSlice({

  name: 'patient',

  initialState,

  reducers: {

    setSection: (state, action: PayloadAction<any>) => {

      state.section = action.payload; 

    },
    setInfoSection: (state, action: PayloadAction<any>) => {

      state.infoSection = action.payload; 

    },
    setPatient: (state, action: PayloadAction<any>) => {

      state.patient = action.payload; 

    },
    setPatientsList: (state, action: PayloadAction<any>) => {

      state.patientsList = action.payload; 

    },
    setEmergencyContacts: (state, action: PayloadAction<any>) => {

      state.emergencyContacts = action.payload; 

    },
    setPatientIdFromFileExplorer: (state, action: PayloadAction<any>) => {

      state.patientIdFromFileExplorer = action.payload; 

    },
    setRefreshPatientsList: (state, action: PayloadAction<boolean>) => {

      state.refreshPatientsList = action.payload; // auto-reset state. 

    },
    setInitialRendering: (state, action: PayloadAction<boolean>) => {
  
      state.initialRendering = action.payload; 

    }, 
    resetPatient: (state) => { 
        
      state.section =  'patient';  
      state.infoSection = 'overview'; 
      state.patient = null;
      state.patientsList = []; 
      state.emergencyContacts = null; 
      state.patientIdFromFileExplorer = ''; 
      state.initialRendering = true; 

    } 
  },

}); 

// ---------------

export const { 
  setSection, 
  setInfoSection, 
  setPatient, 
  setPatientsList, 
  setEmergencyContacts, 
  setPatientIdFromFileExplorer, 
  setRefreshPatientsList, 
  resetPatient, 
  setInitialRendering, 
 } = patientSlice.actions;

export default patientSlice.reducer;